export const clearCartUserInput = (cartID, key) => {
    return {
        type: 'CLEAR_CART_USER_INPUT',
        id: cartID,
        key: key,
    };
};
export const updateCartUserInput = (cartID, key, value) => {
    return {
        type: 'UPDATE_CART_USER_INPUT',
        id: cartID,
        key: key,
        value: value,
    };
};
